import type { GetVirtualBankStatementsParams } from 'api';

import type { GlobalFiltersState } from 'reduxLocal/slices/globalFiltersSlice';

import type { LocalState } from './localState';

export type Params = LocalState & GlobalFiltersState;

export const apiParams = function (
  state: Partial<Params>
): GetVirtualBankStatementsParams {
  const params: GetVirtualBankStatementsParams = {};

  if (state.filters?.accountNumber && state.filters.accountNumber !== 'All') {
    params['filter[account_number]'] = state.filters.accountNumber;
  }
  if (state.dateRange?.from) {
    params['filter[date_from]'] = state.dateRange.from;
  }
  if (state.dateRange?.to) {
    params['filter[date_to]'] = state.dateRange.to;
  }
  if (state.cursorAfter) {
    params['page[cursor_after]'] = state.cursorAfter;
  }
  if (state.cursorBefore) {
    params['page[cursor_before]'] = state.cursorBefore;
  }
  if (state.includeCursor) {
    params['page[include_cursor]'] = state.includeCursor;
  }

  return params;
};
